import React, { useState, useEffect } from "react";
import "./Productos.css";

const CATALOGO = { prefijo: "CATALOGO  AGOSTO 2026 VIG", paginas: 25 };
const productos = Array.from({ length: CATALOGO.paginas }, (_, i) => ({
  imagen: `/productos/${CATALOGO.prefijo}_page-${String(i + 1).padStart(4, "0")}.jpg`,
}));

export const Productos = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    document.title = 'AITA - Catálogo de productos';
  }, []);

  useEffect(() => {
    if (selectedIndex === null) return;
    const handler = (e) => {
      if (e.key === "Escape") setSelectedIndex(null);
      if (e.key === "ArrowLeft")
        setSelectedIndex((i) => (i - 1 + productos.length) % productos.length);
      if (e.key === "ArrowRight")
        setSelectedIndex((i) => (i + 1) % productos.length);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [selectedIndex]);

  return (
    <div
      className="productos-container"
      style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url('/fondoproductos.png')" }}
    >
      <div className="inner-productos">
        <h2 className="titulo-productos">Catálogo de Productos AITA</h2>

        <div className="catalogo-grid">
          {productos.map((p, i) => (
            <div
              className="catalogo-item"
              key={i}
              onClick={() => setSelectedIndex(i)}
            >
              <img
                src={p.imagen}
                alt={`Catálogo página ${i + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {selectedIndex !== null && (
        <div className="lightbox-overlay" onClick={() => setSelectedIndex(null)}>
          <button
            className="lightbox-close"
            onClick={() => setSelectedIndex(null)}
            aria-label="Cerrar"
          >
            ✕
          </button>

          <button
            className="lightbox-prev"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedIndex((i) => (i - 1 + productos.length) % productos.length);
            }}
            aria-label="Anterior"
          >
            ‹
          </button>

          <img
            src={productos[selectedIndex].imagen}
            alt={`Catálogo página ${selectedIndex + 1}`}
            className="lightbox-img"
            onClick={(e) => e.stopPropagation()}
          />

          <button
            className="lightbox-next"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedIndex((i) => (i + 1) % productos.length);
            }}
            aria-label="Siguiente"
          >
            ›
          </button>

          <p className="lightbox-counter">
            {selectedIndex + 1} / {productos.length}
          </p>
        </div>
      )}
    </div>
  );
};
